import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { table } from 'console';
import { ca, id } from 'date-fns/locale';
import { GridUtil } from './GridUtil';
import { Util } from 'src/app/services/Util';
import { NgZone } from '@angular/core';
import { first, take } from 'rxjs';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { LayoutService } from 'src/@vex/services/layout.service';
import { ITableParams } from './ITableParams';
import { IFilterParam } from './IFilterParam';
import { IColumn } from './IColumn';
import { QueryOperand } from './QueryOperand';
import { FieldDataType } from './FieldDataType';
import { AuthService } from 'src/app/services/http-services/authservice.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})

export class GridComponent implements OnInit, OnChanges, AfterViewChecked, AfterViewInit {

  @Input() columns: IColumn[] = [];
  @Input() rows: any = [];
  @Input() tableParams: ITableParams;
  @Input() multiSelect: boolean;
  @Input() allowCopy: boolean;
  @Input() selectAll: boolean;
  @Input() gridName: string;
  @Input() allowEdit: boolean = true;
  @Input() allowAdd: boolean = true;
  @Input() allowView: boolean = true;
  @Input() allowDelete: boolean = true;
  @Input() allowExport: boolean = true;

  @Output() refreshDataFromServer = new EventEmitter<ITableParams>();
  @Output() rowSelected = new EventEmitter<any[]>();
  @Output() editClicked = new EventEmitter<any>();
  @Output() deleteClicked = new EventEmitter<any[]>();
  @Output() viewAllClicked = new EventEmitter<any[]>();
  @Output() exportClicked = new EventEmitter<any>();
  @Output() addClicked = new EventEmitter<any>();
  @Output() multiSelectClicked = new EventEmitter<any[]>();
  @Output() selectAllClicked = new EventEmitter<any[]>();
  @Output() copyClicked = new EventEmitter<any[]>();

  searchable: boolean = false;
  advanceSearch: boolean = false;
  disableEdit: boolean = false;
  disableDelete: boolean = false;
  disableView: boolean = false;
  disableExport: boolean = false;
  disableAdd: boolean = false;
  renderedRows: {}[] = [];
  pageList: number[] = [];
  sortedFieldByAsc = ""
  sortedFieldByDec = ""
  private filterParams: Map<string, any> = new Map<string, any>();
  private gridDataLoadedEvent: any;
  readonly operationTypes = ['==', '!=', 'lk', '!lk', '>', '<', '>=', '<='];

  private readonly maxRenderedRowsCount = 50;
  selectedRowIndexToScroll?: number;
  isRowScrolled: boolean = false;
  private previouslySelectedIndexes: number[] = null;
  private lastPageMoved: boolean = false;
  initialX: number = 0;
  initialWidth: number = 0;
  resizingColumnIndex: number | null = null;
  readonly defaultWidth = 160; // Default width for columns
  searchClicked: boolean = false;
  isMobile: boolean = false;
  constructor(private cdRef: ChangeDetectorRef, private eventService: EventService, private layoutService: LayoutService, private authService: AuthService) {
    this.isMobile = layoutService.isMobile();
  }
  ngAfterViewInit() {
    const saved = sessionStorage.getItem(`columnWidths`);
    if (saved) {
      const widthMap = JSON.parse(saved);
      if (widthMap) {
        this.columns.forEach(col => {
          let key = `${col.fieldName}_${this.gridName}`;
          if (widthMap[key]) {
            let thElement = document.getElementById(col.fieldName) as HTMLElement;
            if (thElement) {
              thElement.style.width = `${widthMap[key]}px`;
            }
          }
        });
      }
    }
    this.cdRef.detectChanges(); // Ensure the view is updated
  }
  ngOnInit(): void {
    this.lastPageMoved = GridUtil.isMovedToLastPage(this.gridName);
    this.searchable = this.columns.findIndex(x => x.searchable) !== -1;
    const clearGridSelection = GridUtil.getGridSelection();
    if (clearGridSelection) {
      GridUtil.clearSessionStorage(this.gridName);
    }
    const selectedSearchData = GridUtil.getTableSearchParams(this.gridName);
    const selectedSearchParams = selectedSearchData.tableParams;
    this.advanceSearch = selectedSearchData.isAdvanceSearch;

    console.log(selectedSearchData,"Search");
    

    if (Array.isArray(selectedSearchParams) && selectedSearchParams.length > 0) {
      this.searchClicked = true;
    }
    this.gridDataLoadedEvent = this.eventService.gridDataLoadedEvent.pipe(take(2)).subscribe((value: any) => {
      const selectedIndex = GridUtil.getSelectedIndex(this.gridName);
      if (!this.searchClicked) {
        this.processEnableDisableButtons(false);
        if (selectedIndex?.length) {
          this.selectedRowIndexToScroll = selectedIndex[0];
          const selectedTableParams = GridUtil.getTableParams(this.gridName);
          const pageInfo = selectedTableParams?.pageInfo;
          // Check if the page exists and if the page number or page size has changed
          if (
            pageInfo &&
            (Number(pageInfo.pageSize) !== Number(this.tableParams.pageInfo.pageSize) ||
              Number(pageInfo.page) !== Number(this.tableParams.pageInfo.page) && !this.searchClicked)
          ) {
            this.tableParams = selectedTableParams;
            this.refreshData();

          }
          this.rowSelected.emit(selectedIndex);
          this.scrollToSelectedRow(selectedIndex[0]);
        }
        else {
          if (this.tableParams.pageInfo.pageCount > 0 && !this.lastPageMoved) {            
            this.goToLastPageAndSelectLastRow(); //no previous record selected, go to the last page and select the last row
          }
        }
      } else {
        selectedSearchParams.forEach(element => {
          let el = document.getElementById('search_' + element.fieldName) as HTMLInputElement;
          let elOp = document.getElementById('oprand_' + element.fieldName) as HTMLInputElement;
          if (el) {
            el.value = element.fieldValue;
            if (elOp) { 
              elOp.value = QueryOperand[element.queryOperand];
            }
            setTimeout(() => {
              // Create and dispatch the Enter key event
              const enterEvent = new KeyboardEvent('keyup', {
                key: 'Enter',
                code: 'Enter',
                keyCode: 13,
                which: 13,
                bubbles: true
              });
              el.focus();
              el.dispatchEvent(enterEvent);
            });
          }
          

          this.filterParams.set(element.fieldName, { fieldValue: element.fieldValue })
        });
        this.rowSelected.emit(selectedIndex);
      }

    });
    this.lastPageMoved = false; // Reset the flag for last page movement
  }

  onResizeMouseDown(event: MouseEvent, columnIndex: number) {
    event.preventDefault();
    event.stopPropagation();
    const thElement = (event.target as HTMLElement).parentElement as HTMLElement;
    const startX = event.clientX;
    // offsetWidth/getBoundingClientRect() includes padding, borders, and table layout adjustments,
    // which can cause jumps during drag. We read from style.width to get the actual set width.
    const startWidth = parseFloat(thElement.style.width.replace('px', ''));

    const mouseMoveHandler = (e: MouseEvent) => {
      const dx = e.clientX - startX;
      const newWidth = Math.max(startWidth + dx, this.defaultWidth); // minimum width

      // Apply width directly to header cell
      thElement.style.width = `${newWidth}px`;
      const columnId = this.columns[columnIndex].fieldName;
      this.updateColumnWidth(columnId, newWidth);
    };

    const mouseUpHandler = () => {
      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);

    };

    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  }

  updateColumnWidth(field: string, newWidth: number) {
    const stored = sessionStorage.getItem(`columnWidths`);
    let widthMap = JSON.parse(stored);
    if (widthMap === null || typeof widthMap !== 'object') {
      widthMap = {};
    }
    let key = `${field}_${this.gridName}`;
    widthMap[key] = newWidth; // update the single field

    sessionStorage.setItem(`columnWidths`, JSON.stringify(widthMap));
  }

  onMouseUp = () => {
    this.resizingColumnIndex = null;
    document.removeEventListener('mouseup', this.onMouseUp);
  };
  selectedIndexesHaveChanged(selectedIndex: number[]): boolean {
    let indexesAreTheSame = true;
    if (!this.previouslySelectedIndexes) {
      indexesAreTheSame = false;
    }
    else if (selectedIndex && this.previouslySelectedIndexes && selectedIndex.length == this.previouslySelectedIndexes.length) {
      for (let i = 0; i < selectedIndex.length; i++) {
        if (selectedIndex[i] != this.previouslySelectedIndexes[i]) {
          indexesAreTheSame = false;
          break;
        }
      }
    }
    else {
      indexesAreTheSame = false;
    }
    return !indexesAreTheSame;
  }
  ngOnDestroy() {
    if (this.gridDataLoadedEvent) {
      this.gridDataLoadedEvent.unsubscribe();
    }
  }
  ngAfterViewChecked() {
    const selectedIndex = GridUtil.getSelectedIndex(this.gridName);
    this.processEnableDisableButtons(false);
    if (selectedIndex?.length && this.selectedIndexesHaveChanged(selectedIndex)) {
      this.selectedRowIndexToScroll = selectedIndex[0];
      this.rowSelected.emit(selectedIndex);

      setTimeout(() => {
        if (this.selectedRowIndexToScroll != null && !this.isRowScrolled) {

          const rowElement = document.getElementById(`${selectedIndex[0]}`);
          if (rowElement) {
            rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            this.isRowScrolled = true; // set flag to prevent multiple scrolls
          }
        }

      });
    }
    this.previouslySelectedIndexes = selectedIndex;
  }
  scrollToSelectedRow(selectedIndex: any) {
    setTimeout(() => {
      if (this.selectedRowIndexToScroll != null && !this.isRowScrolled) {

        const rowElement = document.getElementById(`${selectedIndex}`);
        if (rowElement) {
          rowElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          this.isRowScrolled = true; // set flag to prevent multiple scrolls
        }
      }
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === "rows" && this.tableParams.tableMode === TableMode.clientProcessing) {
        this.refreshData();
      }
      if (propName === "tableParams") {
        this.pageList = [...range(this.tableParams.pageInfo.pageCount, 1)];
      }
    }
    this.processEnableDisableButtons(false);
  }

  protected refreshData() {
    if (this.tableParams.tableMode === TableMode.clientProcessing) {
      const filterMap = new Map();
      const filterParams = this.tableParams.filterParams;

      // filterParams.forEach(x =>{
      //   filterMap.set(x.fieldName, x);
      // })

      // this.renderedRows = this.rows.map((x) =>{
      //
      //   x[''] =
      //   return x
      //})


      // const tbody = document.getElementById('cptbody');
      // const tr = document.createElement('tr');
      //
      // if(tbody){
      //   for(let i = 0; i < this.rows.length; i++){
      //     tbody.appendChild(document.createElement('tr'));
      //   }
      //   this.renderedRows = new CPipe<{}>(this.maxRenderedRowsCount, this.rows);
      //
      // }

      //const apxRowHeight = tbody.firstElementChild?.clientHeight;
    }
    else {
      this.refreshDataFromServer.emit(this.tableParams);
    }
    console.log(this.tableParams, "Grid_tableparams");
  }


  onScroll(event) {
    let ele = event.currentTarget as HTMLElement;
    let scrollTop = ele.scrollTop;
    let scrollLeft = ele.scrollLeft;
    let height = ele.firstElementChild.clientHeight;
  }

  onMultiSelectChange(event) {
    this.multiSelect = !this.multiSelect;
    var btn = document.getElementById("selectAll") as HTMLInputElement;
    if (btn!.checked && !this.multiSelect) {
      this.multiSelect = false;
      btn.click(); // uncheck the select all checkbox
    }
    this.multiSelectClicked.emit(this.selectedRowsIndex);
  }

  onAdvanceSearchChange(event) {
    this.advanceSearch = !this.advanceSearch;
  }

  onExportClicked(event) {
    this.exportClicked.emit();
  }

  onAddClicked(event) {
    this.addClicked.emit();
  }

  onEditClicked(event) {
    this.editClicked.emit(this.selectedRowsIndex[0]);
  }

  onDeleteClicked(event) {
    this.deleteClicked.emit(this.selectedRowsIndex);
  }
  onViewClicked(event) {
    this.viewAllClicked.emit(this.selectedRowsIndex);
  }

  onNextClicked() {
    const { page, pageCount } = this.tableParams.pageInfo;
    if (page < pageCount) {
      this.tableParams.pageInfo.page++;
      GridUtil.setTableParams(this.gridName, this.tableParams)
      this.refreshData();
    }
  }

  onPreviousClicked() {
    const { page } = this.tableParams.pageInfo;
    if (page > 1) {
      this.tableParams.pageInfo.page--;
      GridUtil.setTableParams(this.gridName, this.tableParams)
      this.refreshData();
    }
  }

  goToLastPageAndSelectLastRow() {
    //debugger
    this.lastPageClicked(null);
    const lastRowIndex = this.tableParams.pageInfo.recordCount % this.tableParams.pageInfo.pageSize || this.tableParams.pageInfo.pageSize; // Calculate the last row index based on the record count and page size
    if (this.tableParams.pageInfo.recordCount > 0) {
      setTimeout(() => {
        if (lastRowIndex >= 0 && !this.lastPageMoved) {
          const lastRowCheckbox = document.getElementById(`${lastRowIndex}`) as HTMLInputElement;
          if (lastRowCheckbox && !lastRowCheckbox.checked) {
            this.scrollToSelectedRow(lastRowIndex);
            this.changeCheckState(parseInt(lastRowCheckbox.id) + 1, lastRowCheckbox.localName);
            this.rowSelected.emit([lastRowIndex - 1]);
            this.lastPageMoved = true;
            GridUtil.setTableParams(this.gridName, this.tableParams);
            GridUtil.movedToLastPage(this.gridName);
          }
        }
      }, 500);
    } else {
      this.lastPageMoved = true; // If there are no records, set the flag to true
    }

  }
  onPageChanged(event) {
    const page = event.target.value as number;
    this.tableParams.pageInfo.page = page;
    GridUtil.setTableParams(this.gridName, this.tableParams)
    this.refreshData();
  }

  firstPageClicked(event) {
    this.tableParams.pageInfo.page = 1;
    GridUtil.setTableParams(this.gridName, this.tableParams)
    this.refreshData();
  }
  lastPageClicked(event) {
    this.tableParams.pageInfo.page = this.tableParams.pageInfo.pageCount;
    GridUtil.setTableParams(this.gridName, this.tableParams)
    this.refreshData();
  }
  onPageSizeChanged(event) {
    const pageSize = event.target.value as number;
    this.tableParams.pageInfo.pageSize = pageSize;
    GridUtil.setTableParams(this.gridName, this.tableParams)
    this.refreshData();
  }

  operationChangeHandler(event) {
    const column = event.currentTarget.name;
    const operation = event.currentTarget.value;
    let currentValue = this.filterParams.get(column);

    if (currentValue) {
      currentValue.operation = QueryOperand[operation];
      const tempFilterParams = [...this.tableParams.filterParams];
      this.tableParams.filterParams = [];
      this.filterParams.forEach((value, key) => {
        const cFilterParams = tempFilterParams.find(x => x.fieldName = key);
        if (value !== "") {
          const fieldDataType = this.getFieldType(key);
          const rValue = this.normaLizeFieldValue(value.fieldValue, fieldDataType);
          let filter: IFilterParam = {
            fieldName: key,
            fieldValue: rValue,
            queryOperand: column === key ? currentValue.operation : cFilterParams.queryOperand,
            static: value.static
          };
          this.upsertFilter(this.tableParams.filterParams, filter);

          const selectedSearchData = GridUtil.getTableSearchParams(this.gridName);
          const selectedSearchParams = selectedSearchData.tableParams;
          // update saved search parameter when oprand change
          this.upsertFilter(selectedSearchParams, filter);
          GridUtil.setTableSearchParams(this.gridName, selectedSearchParams, this.advanceSearch);
        }
      });
      GridUtil.setTableParams(this.gridName, this.tableParams);
      this.refreshData();
    }
  }
 upsertFilter  (filters: IFilterParam[], newFilter: IFilterParam)  {
    const index = filters.findIndex(f => f.fieldName === newFilter.fieldName);

    if (index > -1) {
      filters[index] = newFilter; // replace existing
    } else {
      filters.push(newFilter); // insert new
    }
  };

  getOperation(column: string): QueryOperand {
    if (this.advanceSearch) {
      const ele = document.querySelector(`select.${column}`) as HTMLSelectElement;
      console.log(ele.value,"Seravj");
      
      return QueryOperand[ele.value];
    }
    else {
      return QueryOperand["=="];
    }
  }

  getFieldType(fieldName: string): FieldDataType {
    return this.columns.find(x => x.fieldName === fieldName).fieldDataType;
  }

  normaLizeFieldValue(fieldValue: string, fieldDataType: FieldDataType): string {
    if (fieldValue.toLowerCase().includes('short') || fieldValue.toLowerCase().includes('short answer question')) {
      fieldValue = 'SAQ';
    }
    switch (fieldDataType) {
      case FieldDataType.enum:
        return fieldValue.split(" ").join("");
      case FieldDataType.boolean:
        return fieldValue === 'No' ? 'false' : 'true';
      default:
        return fieldValue;
    }
  }

  isSelected(index: number, rowid: number): boolean {
    let selectedIndex = GridUtil.getSelectedIndex(this.gridName);
    let selectedDataID = GridUtil.getSelectedDataID(this.gridName);
    if (this.tableParams.selectAll) {
      this.multiSelect = true; // if select all is checked, multiSelect is enabled
      GridUtil.setRowCliclk(this.gridName, this.selectedRowsIndex, this.selectedDataRowsId);

      this.rowSelected.emit(this.selectedRowsIndex); // emit selected rows index
      return true; // if select all is checked, all rows are selected
    }
    if (selectedIndex && selectedIndex.includes(index) && selectedDataID && selectedDataID.includes(rowid)) {
      this.selectedRowIndexToScroll = index; // store index to scroll later
      return true;
    }

    return false;
  }
  searchKeyUpHandler(search) {
    //if key is enter key
    if (search!.keyCode === 13) {
      this.searchBtnCliked();
    }
    else {
      let column = search.currentTarget.name;
      let fieldValue = search.currentTarget.value.trim();
      let currentValue = this.filterParams.get(column);
      if (currentValue) {
        currentValue.fieldValue = fieldValue;
      }
      // const ops = ;
      this.filterParams.set(column, { fieldValue });
    }
  }

  searchBtnCliked() {
    this.tableParams.filterParams = [...this.tableParams.filterParams.filter(x => x.static)];
    let searchParams: IFilterParam[] = [];
    this.filterParams.forEach((value, key) => {
      if (value.fieldValue !== "") {
        const queryOperand = this.getOperation(key);
        const fieldDataType = this.getFieldType(key);
        const rValue = this.normaLizeFieldValue(value.fieldValue, fieldDataType);
        let filter: IFilterParam = {
          fieldName: key,
          fieldValue: rValue,
          queryOperand: queryOperand,
          static: value.static
        };
        this.upsertFilter(searchParams, filter);        
        this.upsertFilter(this.tableParams.filterParams, filter);

      }
    });
    GridUtil.setTableSearchParams(this.gridName, searchParams,this.advanceSearch);
    this.searchClicked = true;
    this.refreshData();
  }

  headerClickHandler(event) {
    let fieldName = event.currentTarget.id;
    if (this.tableParams.sortParam.fieldName === fieldName) {
      this.tableParams.sortParam.orderDirection =
        this.tableParams.sortParam.orderDirection === OrderDir.asc ?
          OrderDir.desc : OrderDir.asc;
    }
    else {
      this.tableParams.sortParam.fieldName = fieldName;
      this.tableParams.sortParam.orderDirection = OrderDir.asc;
    }
    this.sortedFieldByAsc = this.tableParams.sortParam.orderDirection === OrderDir.asc ? fieldName : null;
    this.sortedFieldByDec = this.tableParams.sortParam.orderDirection === OrderDir.desc ? fieldName : null;
    this.refreshData();
  }

  rowClickHandler(event) {
    const eleId = event.currentTarget.id;
    this.changeCheckState(parseInt(eleId) + 1, event.target.localName);
    GridUtil.movedToLastPage(this.gridName, null);
    GridUtil.setTableParams(this.gridName, this.tableParams);
    GridUtil.setRowCliclk(this.gridName, this.selectedRowsIndex, this.tableParams);
    this.rowSelected.emit(this.selectedRowsIndex);
  }

  get selectedRowsIndex() {
    const elements = document.getElementsByName("selected") as NodeListOf<HTMLInputElement>;
    const ids = [];
    elements.forEach(x => {
      if (x.checked) {
        const idx = parseInt(x.id) - 1;
        ids.push(idx);
      }
    });
    return this.multiSelect ? ids : ids.length > 0 ? [ids[ids.length - 1]] : ids;
  }
  get selectedDataRowsId() {
    const elements = document.getElementsByName("selected") as NodeListOf<HTMLInputElement>;
    const ids = [];
    elements.forEach(x => {
      if (x.checked) {
        const idx = (parseInt(x.attributes['rowid'].value));
        ids.push(idx);
      }
    });
    return this.multiSelect ? ids : ids.length > 0 ? [ids[ids.length - 1]] : ids;
  }

  processEnableDisableButtons(skipDetectChanges: boolean) {
    this.disableEdit = this.selectedRowsIndex.length === 0 || this.selectedRowsIndex.length > 1 || !this.allowEdit;
    this.disableDelete = this.selectedRowsIndex.length === 0 || !this.allowDelete;
    this.disableView = this.selectedRowsIndex.length === 0 || this.selectedRowsIndex.length > 1 || !this.allowView;
    this.disableExport = !this.allowExport;
    this.disableAdd = !this.allowAdd;

    if (!skipDetectChanges) {
      this.cdRef.detectChanges();
    }
  }
  getRowNumber(i: number): number {
    const row = i + 1 + this.tableParams.pageInfo.pageSize * (this.tableParams.pageInfo.page - 1);
    return row;
  }

  changeCheckState(id: number, elementName: string) {
    const ele = document.getElementById(`${id}`) as HTMLElement;
    if (elementName !== 'input') {
      if (this.multiSelect) {
        ele['checked'] = !ele['checked'];
      }
      else {
        ele['checked'] = true;
      }
    }
  }
  onSelectAllChange(event) {
    const isChecked = !this.selectAll;
    const elements = document.getElementsByName("selected") as NodeListOf<HTMLInputElement>;
    elements.forEach(x => x.checked = isChecked);
    this.processEnableDisableButtons(false);
    this.tableParams.selectAll = isChecked;
    this.selectAll = isChecked;
    this.multiSelect = isChecked; // if select all is checked, multiSelect is enabled
    GridUtil.setTableParams(this.gridName, this.tableParams);
    GridUtil.setRowCliclk(this.gridName, this.selectedRowsIndex, this.selectedDataRowsId);
    this.rowSelected.emit(this.selectedRowsIndex);
    this.selectAllClicked.emit();
  }

  cellMouseOver(event) {
    const ele = event.currentTarget;
    if (ele.clientWidth < ele.scrollWidth) {
      ele.title = ele.innerText;
    }
  }

  renderRows(curIdx: number, rowsCount: number, scrollDir: ScrollDir) {
    if (this.rows) {

      if (curIdx === 0 && rowsCount === 0) {
        for (let i = curIdx; i < 50; i++) {
          // this.renderedRows.push({
          //   idx: i,
          //   data: this.rows[i]
          // })
        }
      }
      if (scrollDir === ScrollDir.down) {
        for (let i = rowsCount; i < 20; i++) {

        }
      }
      else {

      }

    }
  }

  renderCell(c: IColumn, row: any) {
    const dataType = c.fieldDataType;
    const value = row[c.fieldName];
    if (value !== undefined && value !== null) {
      switch (dataType) {
        case FieldDataType.date:
          return new Date(value).toLocaleDateString('en-GB');
        case FieldDataType.dateTime:
          return `${Util.getUserLocalDateTimeString(value,this.authService.user.timezoneOffset)}`;
        case FieldDataType.enum:
          if (typeof (value) === 'string') {
            return value.match(/[A-Z][a-z]+/g).join(" ");
          }
          else {
            return value;
          }
        case FieldDataType.number:
          return Number.parseFloat(value).toLocaleString('en-US');
        case FieldDataType.text:
          return value;
        case FieldDataType.boolean:
          return value === true || value === 1 ? 'Yes' : 'No';
        default:
          return value;
      }
    }
    else {
      return '';
    }
  }
  onRowSelectionChange(rowIndex: number, event) {
    const isChecked = event.target.checked;
    const rowId = rowIndex;

    if (this.multiSelect) {
      const selectedRows = this.selectedRowsIndex;
      if (isChecked) {
        if (!selectedRows.includes(rowId)) {
          selectedRows.push(rowId);
        }
      } else {
        const index = selectedRows.indexOf(rowId);
        if (index > -1) {
          selectedRows.splice(index, 1);
        }
      }
    } else {
      const elements = document.getElementsByName("selected") as NodeListOf<HTMLInputElement>;
      elements.forEach((x) => (x.checked = false));
      event.target.checked = isChecked;
    }
    this.processEnableDisableButtons(false);
    this.rowSelected.emit(this.selectedRowsIndex);
  }

  isRowSelected(rowIndex: number): boolean {
    const rowId = rowIndex;
    return this.selectedRowsIndex.includes(rowId);
  }

  resetRowSelected() {
    this.selectedRowIndexToScroll = null;
    GridUtil.clearSessionStorage(this.gridName);
    this.isRowScrolled = false;
    const elements = document.getElementsByName("selected") as NodeListOf<HTMLInputElement>;
    elements.forEach(x => x.checked = false);
    this.selectedRowIndexToScroll = null;
    this.rowSelected.emit([]);
  }
  onCopyChange(event) {
    if (this.allowCopy) {
      const selectedRows = this.selectedRowsIndex;
      if (selectedRows.length > 0) {
        this.copyClicked.emit();
        // navigator.clipboard.writeText(JSON.stringify(copiedData))
        //   .then(() => {
        //     console.log('Copied to clipboard successfully!');
        //   })
        //   .catch(err => {
        //     console.error('Failed to copy: ', err);
        //   });
      } else {
        console.warn('No rows selected to copy.');
      }
    } else {
      console.warn('Copying is not allowed.');
    }
  }
  // onTyping(event: Event) {
  //   const el = event.target as HTMLInputElement;
  //   if (!el) return;
  //   const hasStar = el.value.includes('*');
  //   this.advanceSearch = hasStar;
  //   // ensure view updates if this method is called outside Angular zone
  //   this.cdRef.detectChanges();
  // }
}

export enum OrderDir {
  asc = 0,
  desc = 1
}

export enum TableMode {
  clientProcessing = 'CP',
  serverProcessing = 'SP'
}

export enum ScrollDir {
  up,
  down
}

export function range(size: number, startAt: number = 0): ReadonlyArray<number> {
  return [...Array(size).keys()].map(i => i + startAt);
}
